"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdwebLoginBodyToJSON = exports.ThirdwebLoginBodyFromJSONTyped = exports.ThirdwebLoginBodyFromJSON = void 0;
function ThirdwebLoginBodyFromJSON(json) {
    return ThirdwebLoginBodyFromJSONTyped(json, false);
}
exports.ThirdwebLoginBodyFromJSON = ThirdwebLoginBodyFromJSON;
function ThirdwebLoginBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signedPayload': json['signedPayload'],
    };
}
exports.ThirdwebLoginBodyFromJSONTyped = ThirdwebLoginBodyFromJSONTyped;
function ThirdwebLoginBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signedPayload': value.signedPayload,
    };
}
exports.ThirdwebLoginBodyToJSON = ThirdwebLoginBodyToJSON;
